// extracted by mini-css-extract-plugin
export default {"LayoutContent":"PriceEdit_LayoutContent__VGf7v"};